/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize Medical Parameters Management View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './medicalParametersManagementView';

export const mapStateToPropsMedParamManagement = mapStateToProps;
export const mapDispatchToPropsMedParamManagement = mapDispatchToProps;

export default connect(
  mapStateToPropsMedParamManagement,
  mapDispatchToPropsMedParamManagement
)(View);
